// extracted by mini-css-extract-plugin
export default {"panel":"PruebasAlergia_panel__jl-+j","subHeader":"PruebasAlergia_subHeader__RtF1l","customCheckboxText":"PruebasAlergia_customCheckboxText__QE1WM"};